import { Spinner, Size } from 'ngx-spinner';

export enum TABLE_LIST {
    ABSENCE = 'ABSENCE',
    OVERTIME = 'OVERTIME',
    EMPLOYEE = 'EMPLOYEE',
    LOOKUP = 'LOOKUP',
    PORTAL_USER = 'PORTAL_USER',
    REQUESTS = 'REQUESTS'
}

export enum FILE_SUBFOLDERS {
    ABSENCE = 'absences',
    EMPLOYEE = 'employee'
}


export const WORK_START_DATE_FORMAT = {
    parse: {
        dateInput: ['DD.MM.YYYY']
    },
    display: {
        dateInput: 'DD.MM.YYYY',
        monthYearLabel: 'MMMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY',
    },
};

export class AppConstants {
    public static WORKSTARTDATE_FORMAT = 'dd.MM.yyyy';
    public static ABSENCE_EXCUSE_REASON_LOOKUP_CODE = 'ABSENCE_EXCUSE_REASON';
    public static OVERTIME_EXCUSE_REASON_LOOKUP_CODE = 'OVERTIME_EXCUSE_REASON';
    public static UPLOADABLE_FILE_TYPES  = ['jpeg', 'jpg', 'png', 'pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'];
    public static UPLOADABLE_IMAGE_TYPES = ['jpeg', 'jpg', 'png', 'gif', 'tiff'];
    public static FILE_UPLOAD_LIMIT = 10;
    public static FILE_UPLOAD_MINLIMIT = 0;
    public static ALPHABET = 'AaBbCcÇçDdEeFfGgĞğHhIıİiJjKkLlMmNnOoÖöPpQqRrSsŞşTtUuÜüVvWwXxYyZz0123456789';
    public static REQUEST_TALEP_SIKAYET = 40;
    public static MOMENT_DATETIME_FORMAT = 'DD.MM.YYYY HH:mm';
    public static MOMENT_DATETIME_FORMAT_2 = 'YYYY-MM-DDTHH:mm:ss';
    public static MOMENT_TIME_FORMAT = 'HH:mm';
    public static MOMENT_DATE_FORMAT = 'DD.MM.YYYY';
    public static MOMENT_MONTH_FORMAT = 'MM/YYYY';
    public static TCKNO = '/^[0-9]{11}$/.';
    public static GENDER_LOOKUP_CODE = 'GENDER' ;
}

export const spinnersetting: Spinner = {
    type: 'ball-spin-clockwise-fade-rotating',
    size: 'medium' as Size,
    bdColor: 'rgba(46, 46, 46, 1)',
    color: 'blue',
    fullScreen: true,
};

export enum DIALOG_OPERATIONS {
    UPDATE,
    CREATE,
    DELETE
}

export const NETWORK_SPEED_LIMIT = {
   LOW: 2,
   MEDIUM: 4
}

export const PROCESS = {
    UPDATE: 1,
    CREATE: 2
}

